import { render, staticRenderFns } from "./TrainingMaterials.vue?vue&type=template&id=e0bd8352&"
import script from "./TrainingMaterials.vue?vue&type=script&lang=js&"
export * from "./TrainingMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports